"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let RegisterEntry = class RegisterEntry extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getContainer(...args) {
        const [editor] = args;
        return {
            self: this.$fn.urlFor('create_register_entry', {
                register_id: editor.version.register_id,
                version_id: editor.version.version_id,
            }),
            object: 'list',
            data: []
        };
    }
    getPayload(...args) {
        const [editor] = args;
        const exclude = editor.document_type === 'invoice'
            ? ['contract', 'version']
            : (editor.document_type === 'contract' ? ['invoice', 'version'] : ['contract', 'invoice', 'version']);
        const result = editor.isNew ?
            editor.getData({ exclude }) :
            editor.getChanges({ exclude, skipEmbeddedLists: true });
        if (result.invoice && !result.invoice.invoice_number) {
            result.invoice = null;
        }
        if (result.contract && !result.contract.contract_number) {
            result.contract = null;
        }
        return result;
    }
    onDocumentTypeChanged(...args) {
        const [editor] = args;
        const docType = editor.document_type;
        if (editor.isNew) {
            return this.reloadTemplate(editor);
        }
        if (docType == 'invoice' && !editor.invoice) {
            editor.invoice = { id: null, invoice_number: null };
            return;
        }
        if (docType == 'contract' && !editor.contract) {
            editor.contract == { id: null, contract_number: null };
            return;
        }
        editor.invoice = null;
        editor.contract = null;
    }
    reloadTemplate(...args) {
        const [editor] = args;
        return this.$fn
            .fetch('get_register_entry_template', {
            parameters: {
                entry_id: editor.id,
                register_id: editor.version.register_id,
                version_id: editor.version.version_id,
                direction: editor.direction,
                document_type: editor.document_type,
                invoice_id: editor.invoice?.id,
                contract_id: editor.contract?.id
            },
            asResource: true
        })
            .then(resource => {
            this.setData('resource', resource);
            this.setData('editor', resource.editor());
        });
    }
    createNew(...args) {
        const editor = this.editor;
        const resource = this.resource;
        return this.$fn
            .fetch('get_register_entry_template', {
            parameters: {
                register_id: resource.version.register_id,
                version_id: resource.version.version_id,
                direction: resource.direction,
                document_type: resource.document_type,
            },
            asResource: true
        })
            .then(resource => {
            this.setData('resource', resource);
            this.setData('editor', resource.editor());
        });
    }
    onRegisterChanged(...args) {
        const [value] = args;
        this.editor.version.register_id = value.selectedRegisterId;
        this.editor.version.version_id = value.selectedVersionId;
        this.reloadTemplate(this.editor);
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    registerId;
    onRegister_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("registerId");
    }
    versionId;
    onVersion_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("versionId");
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    createTitle;
    defaultTitle;
    registerObj;
    async $$load_registerObj() {
        return this.register;
    }
    resource;
    async $$load_resource() {
        return this.oid
            ? this.$fn.fetch('read_register_entry', { parameters: { id: this.oid }, asResource: true })
            : this.$fn.fetch('get_register_entry_template', {
                parameters: {
                    register_id: this.registerId,
                    version_id: this.versionId,
                    invoice_id: this.invoice ? this.invoice.id : null
                }, asResource: true
            });
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    selectRegister;
    async $$load_selectRegister() {
        return this.resource && this.resource.isNew && this.invoice && !this.registerId && !this.versionId;
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'formName', 'createTitle', 'defaultTitle', 'registerObj', 'resource', 'editor', 'selectRegister', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "registerEntry",
                createTitle: this.$fn.pgettext("RegisterEntry", "New Registry Entry"),
                defaultTitle: this.$fn.pgettext("RegisterEntry", "Edit Entry"),
                registerObj: null,
                resource: null,
                editor: null,
                selectRegister: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get isDeletable() {
        if (this.loaded) {
            return this.oid != null;
        }
        return null;
    }
    get creatingTitle() {
        if (this.loaded) {
            return this.$fn.pgettext("RegisterEntry", "Create new entry");
        }
        return null;
    }
    get editingTitle() {
        if (this.loaded) {
            return '#' + this.resource.entry_number;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.resource.isNew ? this.creatingTitle : this.editingTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5064_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_reloadSlickgrid_5072_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_script_5074_getActionArgs_value($event) {
        this.onRegisterChanged($event.data);
    }
    async act_8564662037462133_script_5074_getActionArgs($event) {
        return {
            value: () => this.act_8564662037462133_script_5074_getActionArgs_value($event),
        };
    }
    async evh_8564662037462133_registerChanged(event, scope) {
        return await this.actions.evh_8564662037462133_registerChanged.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_emit_5078_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data,
        };
    }
    async act_1040167445267876_reloadSlickgrid_5080_getActionArgs($event) {
        return {
            grid: "register",
        };
    }
    async act_1040167445267876_setData_5082_getActionArgs($event) {
        return {
            path: "selectRegister",
            value: false,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1040167445267876_rest_5076_getActionArgs($event) {
        return {
            method: "save",
            container: this.getContainer(this.editor),
            resource: this.editor,
            data: this.getPayload(this.editor),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_script_5084_getActionArgs_value($event) {
        this.onDocumentTypeChanged(this.editor);
    }
    async act_5534025912102772_script_5084_getActionArgs($event) {
        return {
            value: () => this.act_5534025912102772_script_5084_getActionArgs_value($event),
        };
    }
    async evh_5534025912102772_documentTypeChanged(event, scope) {
        return await this.actions.evh_5534025912102772_documentTypeChanged.executeFromDOM(this, event, scope);
    }
    async evh_5534025912102772_reload(event, scope) {
        return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
    }
    async evh_5534025912102772_close(event, scope) {
        return await this.actions.evh_5534025912102772_close.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_emit_5090_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data,
        };
    }
    async evh_5534025912102772_changed(event, scope) {
        return await this.actions.evh_5534025912102772_changed.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_script_5092_getActionArgs_value($event) {
        this.createNew();
    }
    async act_1548630417156826_script_5092_getActionArgs($event) {
        return {
            value: () => this.act_1548630417156826_script_5092_getActionArgs_value($event),
        };
    }
    async evh_1548630417156826_click(event, scope) {
        return await this.actions.evh_1548630417156826_click.executeFromDOM(this, event, scope);
    }
    async evh_1589624209624921_clickPreventStop(event, scope) {
        return await this.actions.evh_1589624209624921_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5064 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5064_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5063 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5064,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5063],
        });
        const act_2248226175642056_closeComponent_5066 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5065 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5066,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5065],
        });
        const act_8564662037462133_reloadComponentData_5068 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_5067 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_5068,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_5067],
        });
        const act_8564662037462133_closeComponent_5070 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_8564662037462133_deleted_5069 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeComponent_5070,
            event: "deleted",
            displayName: "closeComponent",
        });
        const act_8564662037462133_reloadSlickgrid_5072 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8564662037462133_reloadSlickgrid_5072_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_deleted_5071 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadSlickgrid_5072,
            event: "deleted",
            displayName: "reloadSlickgrid",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_5069, evh_8564662037462133_deleted_5071],
        });
        const act_8564662037462133_script_5074 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8564662037462133_script_5074_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_registerChanged_5073 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_script_5074,
            event: "registerChanged",
            displayName: "script",
        });
        const evh_8564662037462133_registerChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_registerChanged_5073],
        });
        const act_1040167445267876_emit_5078 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_5078_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5077 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_5078,
            event: "saved",
            displayName: "emit",
        });
        const act_1040167445267876_reloadSlickgrid_5080 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_5080_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5079 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_5080,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_setData_5082 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_5082_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_5081 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_5082,
            event: "saved",
            displayName: "setData",
        });
        const act_1040167445267876_rest_5076 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_5076_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_saved_5077, evh_1040167445267876_saved_5079, evh_1040167445267876_saved_5081],
        });
        const evh_1040167445267876_submit_5075 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_5076,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5075],
        });
        const act_5534025912102772_script_5084 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5534025912102772_script_5084_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_documentTypeChanged_5083 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_script_5084,
            event: "documentTypeChanged",
            displayName: "script",
        });
        const evh_5534025912102772_documentTypeChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_documentTypeChanged_5083],
        });
        const act_5534025912102772_reloadComponentData_5086 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5534025912102772_reload_5085 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_reloadComponentData_5086,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_5534025912102772_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_reload_5085],
        });
        const act_5534025912102772_closeComponent_5088 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_5534025912102772_close_5087 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_closeComponent_5088,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_5534025912102772_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_close_5087],
        });
        const act_5534025912102772_emit_5090 = new core_1.actions.EmitAction({
            actionArgs: this.act_5534025912102772_emit_5090_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_changed_5089 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_emit_5090,
            event: "changed",
            displayName: "emit",
        });
        const evh_5534025912102772_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_changed_5089],
        });
        const act_1548630417156826_script_5092 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1548630417156826_script_5092_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_click_5091 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_script_5092,
            event: "click",
            displayName: "script",
        });
        const evh_1548630417156826_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_click_5091],
        });
        const act_1589624209624921_closeComponent_5094 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1589624209624921_clickPreventStop_5093 = new core_1.actions.EventHandlerImpl({
            action: act_1589624209624921_closeComponent_5094,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1589624209624921_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1589624209624921_clickPreventStop_5093],
        });
        return {
            act_7315092382398562_closeModal_5064,
            evh_7315092382398562_close_5063,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5066,
            evh_2248226175642056_close_5065,
            evh_2248226175642056_close,
            act_8564662037462133_reloadComponentData_5068,
            evh_8564662037462133_reload_5067,
            evh_8564662037462133_reload,
            act_8564662037462133_closeComponent_5070,
            evh_8564662037462133_deleted_5069,
            act_8564662037462133_reloadSlickgrid_5072,
            evh_8564662037462133_deleted_5071,
            evh_8564662037462133_deleted,
            act_8564662037462133_script_5074,
            evh_8564662037462133_registerChanged_5073,
            evh_8564662037462133_registerChanged,
            act_1040167445267876_emit_5078,
            evh_1040167445267876_saved_5077,
            act_1040167445267876_reloadSlickgrid_5080,
            evh_1040167445267876_saved_5079,
            act_1040167445267876_setData_5082,
            evh_1040167445267876_saved_5081,
            act_1040167445267876_rest_5076,
            evh_1040167445267876_submit_5075,
            evh_1040167445267876_submit,
            act_5534025912102772_script_5084,
            evh_5534025912102772_documentTypeChanged_5083,
            evh_5534025912102772_documentTypeChanged,
            act_5534025912102772_reloadComponentData_5086,
            evh_5534025912102772_reload_5085,
            evh_5534025912102772_reload,
            act_5534025912102772_closeComponent_5088,
            evh_5534025912102772_close_5087,
            evh_5534025912102772_close,
            act_5534025912102772_emit_5090,
            evh_5534025912102772_changed_5089,
            evh_5534025912102772_changed,
            act_1548630417156826_script_5092,
            evh_1548630417156826_click_5091,
            evh_1548630417156826_click,
            act_1589624209624921_closeComponent_5094,
            evh_1589624209624921_clickPreventStop_5093,
            evh_1589624209624921_clickPreventStop,
            save: act_1040167445267876_rest_5076,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], RegisterEntry.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RegisterEntry.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], RegisterEntry.prototype, "registerId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('registerId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RegisterEntry.prototype, "onRegister_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], RegisterEntry.prototype, "versionId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('versionId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RegisterEntry.prototype, "onVersion_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], RegisterEntry.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RegisterEntry.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], RegisterEntry.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RegisterEntry.prototype, "onSize", null);
RegisterEntry = __decorate([
    (0, vue_property_decorator_1.Component)()
], RegisterEntry);
exports.default = RegisterEntry;
vue_property_decorator_1.Vue.component("RegisterEntry", RegisterEntry);
